import {ICreateExpenseVm, IExpenseVm, ProxyContainer} from "../Data/Data";
import {LogoutService} from "./LogoutService";

export class ExpenseDataService {

  static serviceId = "ExpenseDataService";
  static $inject = [
    '$proxy',
    LogoutService.serviceId,
  ];

  constructor(private proxy: ProxyContainer,
              private logout: LogoutService) {

  }

  browse(employeeId: number) {
    return this.logout.catchLogoutResponse(this.proxy.Expenses.browseMultiple({}, {
      employeeId: employeeId,
      skip: 0,
      take: 30,
    })).then(res => res.data);
  }

  get(expenseId: number) {
    return this.logout.catchLogoutResponse(
      this.proxy.Expenses.get({id: expenseId})
    ).then(res => res.data);
  }

  save(expense: IExpenseVm) {
    return this.logout.catchLogoutResponse(this.proxy.Expenses.saveExpense(expense));
  }

  create(expense: ICreateExpenseVm) {
    return this.logout.catchLogoutResponse(this.proxy.Expenses.createExpense(expense));
  }

  delete(expenseId: number) {
    return this.logout.catchLogoutResponse(this.proxy.Expenses.remove({id: expenseId}));
  }
}